// extracted by mini-css-extract-plugin
export default {"simulation-box":"Simulation_simulation-box__pDRB+","simulation-content-wrap":"Simulation_simulation-content-wrap__WDUqE","simulation-content":"Simulation_simulation-content__TlqMO"};